import { render, staticRenderFns } from "./giftItemAdd.vue?vue&type=template&id=11cb2552&scoped=true&"
import script from "./giftItemAdd.vue?vue&type=script&lang=js&"
export * from "./giftItemAdd.vue?vue&type=script&lang=js&"
import style0 from "./giftItemAdd.vue?vue&type=style&index=0&id=11cb2552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb2552",
  null
  
)

export default component.exports